package com.anjuros.website.templates.template4.components

import androidx.compose.runtime.Composable
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.components.shared.ChevronLeftIcon
import com.anjuros.website.components.shared.ChevronRightIcon
import com.anjuros.website.templates.selection.util.Res
import com.anjuros.website.templates.template4.modules.Template4Theme
import com.anjuros.website.templates.template4.modules.getColorOpacity
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.visibility
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import org.jetbrains.compose.web.css.px

@Composable
fun Template4ZoomOverview(modifier: Modifier, imageZoomed:String, onLeftClicked:()->Unit, onRightClicked:()->Unit,
                 onExitClicked:()->Unit){


    Box(
        modifier = modifier.fillMaxSize().displayIfAtLeast(Breakpoint.LG).height(630.px)
            .visibility(if(imageZoomed.isNotEmpty()) Visibility.Visible else Visibility.Hidden)
            .backgroundColor(Template4Theme.OpacityPrimary.getColorOpacity())
    ) {
        Row(modifier = Modifier.fillMaxWidth().align(Alignment.Center),
            horizontalArrangement = Arrangement.SpaceAround,
            verticalAlignment = Alignment.CenterVertically) {
            ChevronLeftIcon(
                modifier = Modifier.color(Colors.White)
                    .cursor(Cursor.Pointer)
                    .onClick { onLeftClicked() })

            Box(modifier = Modifier.size(700.px, 500.px)) {
                // Only once a photo is chosen; an empty src would make the browser request the page itself.
                if (imageZoomed.isNotEmpty()) {
                    AnjurosImage(
                        src = imageZoomed,
                        alt = "gallery",
                        modifier = Modifier.size(700.px, 500.px).objectFit(ObjectFit.Cover)
                    )
                }
            }


            ChevronRightIcon(
                modifier = Modifier.color(Colors.White)
                    .cursor(Cursor.Pointer)
                    .onClick { onRightClicked() })
        }


        Image(
            modifier =  Modifier
                .align(Alignment.TopEnd)
                .size(36.px)
                .margin(top=40.px, right=20.px)
                .cursor(Cursor.Pointer)
                .onClick { onExitClicked() },
            src = Res.Icon.icon_x_white,
            alt = "Close image"
        )
    }
}